const DEFAULT_TOP_RECORDS_LENGTH = 5;

export default (
  recordSizes: Map<unknown, number>,
  top: number = DEFAULT_TOP_RECORDS_LENGTH
): string => {
  const topRecords = Array.from(recordSizes.entries())
    .sort((recordSizeA, recordSizeB) => recordSizeB[1] - recordSizeA[1])
    .slice(0, top)
    .map((record) => `${record[0]} : (${record[1]}b)`);
  return `Top Records:\n${topRecords.join(`\n`)}`;
};
